
import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import {
  Heading,
  BaseText,
  ButtonSecondary,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { SectionTitle } from '@/modules/common/components/SectionTitle';

import { CustomOperationSummary } from '@/modules/trade/services/custom-operations';
import { RequestStatus } from '@/modules/trade/store/trade';
import { trackSectionTitleRetryClick } from '@/modules/trade/views/TradeView/trackers';

import { simplePercentage } from '@/modules/common/helpers/percentage';

const tradePositionsModule = namespace('tradeModule');

@Component({
  components: {
    SectionTitle,
    Heading,
    BaseText,
    ButtonSecondary,
    SkeletonLoader
  }
})
export default class ChartTitle extends Vue {
  @Prop({ type: String, required: false })
  readonly totalBalance?: string;

  @Prop({ type: String, required: false })
  readonly totalEarnings?: string;

  @Prop({ type: Number, required: false })
  readonly yieldValue?: number;

  @Prop({ type: Boolean, default: false })
  readonly isHover!: boolean;

  @tradePositionsModule.State('customOperations')
  readonly customOperations!: CustomOperationSummary[];

  @tradePositionsModule.State('balancesBrokerRequestStatus')
  readonly balancesBrokerRequestStatus!: RequestStatus;

  @tradePositionsModule.Action('fetchBalances')
  readonly fetchBalances!: Function;

  readonly RequestStatus = RequestStatus;

  @Emit('open-balance-details-modal')
  emitOpenBalanceDetailModal() {}

  get yieldValueFormatted() {
    return this.yieldValue || this.yieldValue === 0
      ? simplePercentage(this.yieldValue)
      : '';
  }

  handleSectionClick() {
    if (!this.hasCustomOperations) return;
    this.emitOpenBalanceDetailModal();
  }

  async handleSectionTitleRetryClick() {
    trackSectionTitleRetryClick();
    await this.fetchBalances();
  }

  get hasCustomOperations() {
    return this.customOperations?.length > 0;
  }
}
